<cass-card-slider>
	<mat-card *ngFor='let style of styles'
			[ngClass]='{"selected": style.id === selectedStyle?.id}'
			(click)='selectStyle(style)'
			>
		<mat-card-title class="branding--select-style-card--label branding--select-style-card--label--{{style.id}}">{{ style.label }}</mat-card-title>
		<mat-card-subtitle class="branding--select-style-card--description branding--select-style-card--description--{{style.id}}">{{ style.description }}</mat-card-subtitle>
		<mat-card-content>
			<div class="branding--select-style-card--image branding--select-style-card--image--{{style.id}}"></div>
		</mat-card-content>
	</mat-card>
</cass-card-slider>
